

import React from "react";
import { Box, Button, Typography, Card, CardContent } from "@mui/joy";

const GISLayerAssistant = () => {
  const handleLaunch = () => {
    window.open("https://chatgpt.com/g/g-685beb8db16c819184ec4aa4ff36fac5-gis-layer-assistant", "_blank");
  };

  return (
    <Box display="flex" justifyContent="center" mt={4}>
      <Card variant="outlined" sx={{ maxWidth: 500 }}>
        <CardContent>
          <Typography level="h4" gutterBottom>
            GIS Layer Assistant
          </Typography>
          <Typography level="body1" gutterBottom>
            Use this assistant to search FLD&P’s GIS layer naming conventions, categories, and definitions.
          </Typography>
          <Typography level="body2" fontStyle="italic" gutterBottom>
            Try: "What does the layer `ROW_Easement` represent?"
          </Typography>
          <Button onClick={handleLaunch} variant="solid" color="primary">
            Launch Assistant
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default GISLayerAssistant;